import React, { useEffect, useMemo, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStaticOptions } from "../context/StaticOptionsContext";

const getSelectedColorValue = (colors, colorName) => {
    if (!colorName) {
        return "";
    }

    return colors.find((color) => color.label === colorName)?.value?.toString() || "";
};

const TuzesSzine = () => {
    const navigate = useStepNavigate();
    const { order, updateOrder } = useOrder();
    const { staticOptions } = useStaticOptions();
    const tuzes_szinek = useMemo(() => staticOptions?.tuzes_szinek || [], [staticOptions?.tuzes_szinek]);

    const initialSelectedColor = getSelectedColorValue(tuzes_szinek, order.tuzes_szine_szin_name || "");

    const [selectedOption, setSelectedOption] = useState(initialSelectedColor ? "Igen" : "Nem");
    const [showOptions, setShowOptions] = useState(Boolean(initialSelectedColor));
    const [selectedColor, setSelectedColor] = useState(initialSelectedColor);

    // Csak akkor szinkronizálunk a tárolt értékből, ha abban tényleg van szín. Ha üres, a választást a felhasználó
    // gombjai vezérlik: az "Igen" is üresre állítja a tárolt színt, és ha ez itt "Nem"-re váltana vissza,
    // az első kattintásra nem nyílna meg a színlista.
    useEffect(() => {
        const nextSelectedColor = getSelectedColorValue(tuzes_szinek, order.tuzes_szine_szin_name || "");
        if (nextSelectedColor) {
            setSelectedOption("Igen");
            setShowOptions(true);
        }
        setSelectedColor(nextSelectedColor);
    }, [order.tuzes_szine_szin_name, tuzes_szinek]);

    const handleShowOptions = () => {
        setShowOptions(true);
        setSelectedOption("Igen");
        setSelectedColor("");
        updateOrder({
            ...order,
            tuzes_szine_szin_name: "",
        });
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);

        if (option === "Nem") {
            setShowOptions(false);
            setSelectedColor("");
            updateOrder({
                ...order,
                tuzes_szine_szin_name: "",
            });
            return;
        }

        setShowOptions(true);
    };

    const handleColorSelect = (colorId, colorName) => {
        setSelectedColor(colorId);
        updateOrder({
            ...order,
            tuzes_szine_szin_name: colorName,
        });
    };

    const handleBackClick = () => {
        navigate("/EgySzinu");
    };

    const handleNext = () => {
        navigate("/OrrForma");
    };

    const canProceed = selectedOption === "Nem" || (showOptions && selectedOption === "Igen" && selectedColor);

    return (
        <TablerLayout title="Tűzés színe eltérjen a bőr színétől?">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="card-body text-center">
                        <div className="mb-4">
                            <div className="row g-4 justify-content-center">
                                <div className="col-12 col-md-6 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold ${selectedOption === "Nem" ? "btn-primary" : "btn-outline-primary "}`}
                                        style={{ fontSize: 22 }}
                                        onClick={() => handleOptionSelect("Nem")}
                                    >
                                        Nem
                                    </button>
                                </div>
                                <div className="col-12 col-md-6 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className={`btn w-100 py-4 px-3 shadow-sm d-flex flex-column align-items-center fw-bold ${selectedOption === "Igen" ? "btn-primary" : "btn-outline-primary"}`}
                                        style={{ fontSize: 22 }}
                                        onClick={handleShowOptions}
                                    >
                                        Igen
                                    </button>
                                </div>
                            </div>

                            {showOptions && (
                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <div
                                            className="p-3 h-100 d-flex flex-column"
                                            style={{
                                                border: "1px solid #e2e8f0",
                                                backgroundColor: "#f9fafb",
                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                marginTop: "20px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    marginBottom: "10px",
                                                    padding: "10px",
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #e5e7eb",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    color: "black",
                                                    textAlign: "center",
                                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                                }}
                                            >
                                                {selectedColor
                                                    ? `Kiválasztott szín: ${tuzes_szinek.find((c) => c.value.toString() === selectedColor)?.label}`
                                                    : "Nincs kiválasztva szín."}
                                            </div>

                                            <div
                                                className="scrollable-div"
                                                style={{
                                                    maxHeight: "400px",
                                                    overflowY: "auto",
                                                    border: "1px solid #e2e8f0",
                                                    padding: "10px",
                                                    backgroundColor: "#ffffff",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                }}
                                            >
                                                {tuzes_szinek.map((color) => (
                                                    <div
                                                        key={color.value}
                                                        className={`color-option ${
                                                            selectedColor === color.value.toString() ? "selected" : ""
                                                        }`}
                                                        style={{
                                                            padding: "10px",
                                                            marginBottom: "6px",
                                                            cursor: "pointer",
                                                            border: "1px solid #e2e8f0",
                                                            backgroundColor:
                                                                selectedColor === color.value.toString()
                                                                    ? "#81c94a"
                                                                    : "#f8fafc",
                                                            color: "black",
                                                            fontWeight: selectedColor === color.value.toString() ? "600" : "500",
                                                            boxShadow:
                                                                selectedColor === color.value.toString()
                                                                    ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                                                                    : "0 1px 2px rgba(0, 0, 0, 0.1)",
                                                        }}
                                                        onClick={() => handleColorSelect(color.value.toString(), color.label)}
                                                    >
                                                        {color.label}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
                        <StepperNavButton side="right" label="Tovább" onClick={handleNext} disabled={!canProceed} />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default TuzesSzine;